"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/internal-payment-card.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Finternal-payment-card.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelToJSON = exports.cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelFromJSON = exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusToJSON = exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusFromJSON = exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelToJSON = exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelFromJSON = exports.cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodToJSON = exports.cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodFromJSON = exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk = exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk = exports.CardInternalPaymentContextStripeRiskDataRiskAssessment = exports.CardInternalPaymentContextStripeRiskDataFraudChallenge = exports.CardInternalPaymentContextStripeRiskData = exports.CardInternalPaymentContext = exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel = exports.CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus = exports.CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel = exports.CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood = void 0;
const protobufPackage = 'com.step.common.proto';
/**
 * See: https://docs.stripe.com/api/issuing/authorizations/object#issuing_authorization_object-fraud_disputability_likelihood
 */
var CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood;
(function (CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood) {
    CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood["FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET"] = "FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET";
    CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood["UNKNOWN_DISPUTABILITY_LIKELIHOOD"] = "UNKNOWN_DISPUTABILITY_LIKELIHOOD";
    CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood["NEUTRAL_DISPUTABILITY_LIKELIHOOD"] = "NEUTRAL_DISPUTABILITY_LIKELIHOOD";
    CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood["VERY_LIKELY_DISPUTABILITY_LIKELIHOOD"] = "VERY_LIKELY_DISPUTABILITY_LIKELIHOOD";
    CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood["VERY_UNLIKELY_DISPUTABILITY_LIKELIHOOD"] = "VERY_UNLIKELY_DISPUTABILITY_LIKELIHOOD";
    CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood || (exports.CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood = CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood = {}));
var CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel;
(function (CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel) {
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel["FRAUD_CHANNEL_NOT_SET"] = "FRAUD_CHANNEL_NOT_SET";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel["SMS_FRAUD_CHALLENGE_CHANNEL"] = "SMS_FRAUD_CHALLENGE_CHANNEL";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel || (exports.CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel = CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel = {}));
var CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus;
(function (CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus) {
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus["FRAUD_CHALLENGE_STATUS_NOT_SET"] = "FRAUD_CHALLENGE_STATUS_NOT_SET";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus["EXPIRED_FRAUD_CHALLENGE"] = "EXPIRED_FRAUD_CHALLENGE";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus["PENDING_FRAUD_CHALLENGE"] = "PENDING_FRAUD_CHALLENGE";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus["REJECTED_FRAUD_CHALLENGE"] = "REJECTED_FRAUD_CHALLENGE";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus["VERIFIED_FRAUD_CHALLENGE"] = "VERIFIED_FRAUD_CHALLENGE";
    CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus || (exports.CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus = CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus = {}));
var CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel;
(function (CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel) {
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["CARD_TESTING_RISK_LEVEL_NOT_SET"] = "CARD_TESTING_RISK_LEVEL_NOT_SET";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["UNKNOWN_CARD_TESTING_RISK_LEVEL"] = "UNKNOWN_CARD_TESTING_RISK_LEVEL";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["ELEVATED_CARD_TESTING_RISK_LEVEL"] = "ELEVATED_CARD_TESTING_RISK_LEVEL";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["HIGH_CARD_TESTING_RISK_LEVEL"] = "HIGH_CARD_TESTING_RISK_LEVEL";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["HIGHEST_CARD_TESTING_RISK_LEVEL"] = "HIGHEST_CARD_TESTING_RISK_LEVEL";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["NORMAL_CARD_TESTING_RISK_LEVEL"] = "NORMAL_CARD_TESTING_RISK_LEVEL";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["NOT_ASSESSED_CARD_TESTING_RISK_LEVEL"] = "NOT_ASSESSED_CARD_TESTING_RISK_LEVEL";
    CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel || (exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel = CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel = {}));
function createBaseCardInternalPaymentContext() {
    return { vaaRiskScore: '0', stripeRiskData: undefined };
}
exports.CardInternalPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.vaaRiskScore)) {
            message.vaaRiskScore = globalThis.String(object.vaaRiskScore);
        }
        if (isSet(object.stripeRiskData)) {
            message.stripeRiskData = exports.CardInternalPaymentContextStripeRiskData.fromJSON(object.stripeRiskData);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.vaaRiskScore !== undefined && message.vaaRiskScore !== '0') {
            obj.vaaRiskScore = message.vaaRiskScore;
        }
        if (message.stripeRiskData !== undefined) {
            obj.stripeRiskData = exports.CardInternalPaymentContextStripeRiskData.toJSON(message.stripeRiskData);
        }
        return obj;
    },
    create(base) {
        return exports.CardInternalPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInternalPaymentContext();
        message.vaaRiskScore = object.vaaRiskScore ?? '0';
        message.stripeRiskData = (object.stripeRiskData !== undefined && object.stripeRiskData !== null)
            ? exports.CardInternalPaymentContextStripeRiskData.fromPartial(object.stripeRiskData)
            : undefined;
        return message;
    },
};
function createBaseCardInternalPaymentContextStripeRiskData() {
    return {
        fraudChallenges: [],
        verifiedByFraudChallenge: false,
        fraudDisputabilityLikelihood: CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
            .FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET,
        networkRiskScore: undefined,
        riskAssessment: undefined,
    };
}
exports.CardInternalPaymentContextStripeRiskData = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.fraudChallenges)) {
            message.fraudChallenges = object.fraudChallenges.map((e) => exports.CardInternalPaymentContextStripeRiskDataFraudChallenge.fromJSON(e));
        }
        if (isSet(object.verifiedByFraudChallenge)) {
            message.verifiedByFraudChallenge = globalThis.Boolean(object.verifiedByFraudChallenge);
        }
        if (isSet(object.fraudDisputabilityLikelihood)) {
            message.fraudDisputabilityLikelihood =
                cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodFromJSON(object.fraudDisputabilityLikelihood);
        }
        if (isSet(object.networkRiskScore)) {
            message.networkRiskScore = globalThis.String(object.networkRiskScore);
        }
        if (isSet(object.riskAssessment)) {
            message.riskAssessment = exports.CardInternalPaymentContextStripeRiskDataRiskAssessment.fromJSON(object.riskAssessment);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fraudChallenges?.length) {
            obj.fraudChallenges = message.fraudChallenges.map((e) => exports.CardInternalPaymentContextStripeRiskDataFraudChallenge.toJSON(e));
        }
        if (message.verifiedByFraudChallenge !== undefined && message.verifiedByFraudChallenge !== false) {
            obj.verifiedByFraudChallenge = message.verifiedByFraudChallenge;
        }
        if (message.fraudDisputabilityLikelihood !== undefined &&
            message.fraudDisputabilityLikelihood !==
                CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                    .FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET) {
            obj.fraudDisputabilityLikelihood =
                cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodToJSON(message.fraudDisputabilityLikelihood);
        }
        if (message.networkRiskScore !== undefined) {
            obj.networkRiskScore = message.networkRiskScore;
        }
        if (message.riskAssessment !== undefined) {
            obj.riskAssessment = exports.CardInternalPaymentContextStripeRiskDataRiskAssessment.toJSON(message.riskAssessment);
        }
        return obj;
    },
    create(base) {
        return exports.CardInternalPaymentContextStripeRiskData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInternalPaymentContextStripeRiskData();
        message.fraudChallenges =
            object.fraudChallenges?.map((e) => exports.CardInternalPaymentContextStripeRiskDataFraudChallenge.fromPartial(e)) || [];
        message.verifiedByFraudChallenge = object.verifiedByFraudChallenge ?? false;
        message.fraudDisputabilityLikelihood = object.fraudDisputabilityLikelihood ??
            CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                .FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET;
        message.networkRiskScore = object.networkRiskScore ?? undefined;
        message.riskAssessment = (object.riskAssessment !== undefined && object.riskAssessment !== null)
            ? exports.CardInternalPaymentContextStripeRiskDataRiskAssessment.fromPartial(object.riskAssessment)
            : undefined;
        return message;
    },
};
function createBaseCardInternalPaymentContextStripeRiskDataFraudChallenge() {
    return {
        channel: CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
            .FRAUD_CHANNEL_NOT_SET,
        status: CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
            .FRAUD_CHALLENGE_STATUS_NOT_SET,
    };
}
exports.CardInternalPaymentContextStripeRiskDataFraudChallenge = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.channel)) {
            message.channel =
                cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelFromJSON(object.channel);
        }
        if (isSet(object.status)) {
            message.status =
                cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusFromJSON(object.status);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.channel !== undefined &&
            message.channel !==
                CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
                    .FRAUD_CHANNEL_NOT_SET) {
            obj.channel =
                cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelToJSON(message.channel);
        }
        if (message.status !== undefined &&
            message.status !==
                CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                    .FRAUD_CHALLENGE_STATUS_NOT_SET) {
            obj.status = cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.CardInternalPaymentContextStripeRiskDataFraudChallenge.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInternalPaymentContextStripeRiskDataFraudChallenge();
        message.channel = object.channel ??
            CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
                .FRAUD_CHANNEL_NOT_SET;
        message.status = object.status ??
            CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .FRAUD_CHALLENGE_STATUS_NOT_SET;
        return message;
    },
};
function createBaseCardInternalPaymentContextStripeRiskDataRiskAssessment() {
    return { cardTestingRisk: undefined, fraudRisk: undefined };
}
exports.CardInternalPaymentContextStripeRiskDataRiskAssessment = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.cardTestingRisk)) {
            message.cardTestingRisk =
                exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk.fromJSON(object.cardTestingRisk);
        }
        if (isSet(object.fraudRisk)) {
            message.fraudRisk = exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk.fromJSON(object.fraudRisk);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardTestingRisk !== undefined) {
            obj.cardTestingRisk = exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk
                .toJSON(message.cardTestingRisk);
        }
        if (message.fraudRisk !== undefined) {
            obj.fraudRisk = exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk.toJSON(message.fraudRisk);
        }
        return obj;
    },
    create(base) {
        return exports.CardInternalPaymentContextStripeRiskDataRiskAssessment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInternalPaymentContextStripeRiskDataRiskAssessment();
        message.cardTestingRisk =
            (object.cardTestingRisk !== undefined && object.cardTestingRisk !== null)
                ? exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk.fromPartial(object.cardTestingRisk)
                : undefined;
        message.fraudRisk = (object.fraudRisk !== undefined && object.fraudRisk !== null)
            ? exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk.fromPartial(object.fraudRisk)
            : undefined;
        return message;
    },
};
function createBaseCardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk() {
    return {
        invalidAccountNumberDeclineRatePastHour: undefined,
        invalidCredentialsDeclineRatePastHour: undefined,
        cardTestingRiskLevel: CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .CARD_TESTING_RISK_LEVEL_NOT_SET,
    };
}
exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.invalidAccountNumberDeclineRatePastHour)) {
            message.invalidAccountNumberDeclineRatePastHour = globalThis.String(object.invalidAccountNumberDeclineRatePastHour);
        }
        if (isSet(object.invalidCredentialsDeclineRatePastHour)) {
            message.invalidCredentialsDeclineRatePastHour = globalThis.String(object.invalidCredentialsDeclineRatePastHour);
        }
        if (isSet(object.cardTestingRiskLevel)) {
            message.cardTestingRiskLevel =
                cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelFromJSON(object.cardTestingRiskLevel);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.invalidAccountNumberDeclineRatePastHour !== undefined) {
            obj.invalidAccountNumberDeclineRatePastHour = message.invalidAccountNumberDeclineRatePastHour;
        }
        if (message.invalidCredentialsDeclineRatePastHour !== undefined) {
            obj.invalidCredentialsDeclineRatePastHour = message.invalidCredentialsDeclineRatePastHour;
        }
        if (message.cardTestingRiskLevel !== undefined &&
            message.cardTestingRiskLevel !==
                CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                    .CARD_TESTING_RISK_LEVEL_NOT_SET) {
            obj.cardTestingRiskLevel =
                cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelToJSON(message.cardTestingRiskLevel);
        }
        return obj;
    },
    create(base) {
        return exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRisk();
        message.invalidAccountNumberDeclineRatePastHour =
            object.invalidAccountNumberDeclineRatePastHour ?? undefined;
        message.invalidCredentialsDeclineRatePastHour = object.invalidCredentialsDeclineRatePastHour ??
            undefined;
        message.cardTestingRiskLevel = object.cardTestingRiskLevel ??
            CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .CARD_TESTING_RISK_LEVEL_NOT_SET;
        return message;
    },
};
function createBaseCardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk() {
    return { fraudScore: undefined };
}
exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.fraudScore)) {
            message.fraudScore = globalThis.String(object.fraudScore);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fraudScore !== undefined) {
            obj.fraudScore = message.fraudScore;
        }
        return obj;
    },
    create(base) {
        return exports.CardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardInternalPaymentContextStripeRiskDataRiskAssessmentFraudRisk();
        message.fraudScore = object.fraudScore ?? undefined;
        return message;
    },
};
function cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodFromJSON(object) {
    switch (object) {
        case 0:
        case 'FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET':
            return CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                .FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET;
        case 1:
        case 'UNKNOWN_DISPUTABILITY_LIKELIHOOD':
            return CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                .UNKNOWN_DISPUTABILITY_LIKELIHOOD;
        case 2:
        case 'NEUTRAL_DISPUTABILITY_LIKELIHOOD':
            return CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                .NEUTRAL_DISPUTABILITY_LIKELIHOOD;
        case 3:
        case 'VERY_LIKELY_DISPUTABILITY_LIKELIHOOD':
            return CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                .VERY_LIKELY_DISPUTABILITY_LIKELIHOOD;
        case 4:
        case 'VERY_UNLIKELY_DISPUTABILITY_LIKELIHOOD':
            return CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
                .VERY_UNLIKELY_DISPUTABILITY_LIKELIHOOD;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood.UNRECOGNIZED;
    }
}
exports.cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodFromJSON = cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodFromJSON;
function cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodToJSON(object) {
    switch (object) {
        case CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
            .FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET:
            return 'FRAUD_DISPUTABILITY_LIKELIHOOD_NOT_SET';
        case CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
            .UNKNOWN_DISPUTABILITY_LIKELIHOOD:
            return 'UNKNOWN_DISPUTABILITY_LIKELIHOOD';
        case CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
            .NEUTRAL_DISPUTABILITY_LIKELIHOOD:
            return 'NEUTRAL_DISPUTABILITY_LIKELIHOOD';
        case CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
            .VERY_LIKELY_DISPUTABILITY_LIKELIHOOD:
            return 'VERY_LIKELY_DISPUTABILITY_LIKELIHOOD';
        case CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood
            .VERY_UNLIKELY_DISPUTABILITY_LIKELIHOOD:
            return 'VERY_UNLIKELY_DISPUTABILITY_LIKELIHOOD';
        case CardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihood.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodToJSON = cardInternalPaymentContextStripeRiskDataFraudDisputabilityLikelihoodToJSON;
function cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelFromJSON(object) {
    switch (object) {
        case 0:
        case 'FRAUD_CHANNEL_NOT_SET':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
                .FRAUD_CHANNEL_NOT_SET;
        case 1:
        case 'SMS_FRAUD_CHALLENGE_CHANNEL':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
                .SMS_FRAUD_CHALLENGE_CHANNEL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
                .UNRECOGNIZED;
    }
}
exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelFromJSON = cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelFromJSON;
function cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelToJSON(object) {
    switch (object) {
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
            .FRAUD_CHANNEL_NOT_SET:
            return 'FRAUD_CHANNEL_NOT_SET';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel
            .SMS_FRAUD_CHALLENGE_CHANNEL:
            return 'SMS_FRAUD_CHALLENGE_CHANNEL';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelToJSON = cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeChannelToJSON;
function cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'FRAUD_CHALLENGE_STATUS_NOT_SET':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .FRAUD_CHALLENGE_STATUS_NOT_SET;
        case 1:
        case 'EXPIRED_FRAUD_CHALLENGE':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .EXPIRED_FRAUD_CHALLENGE;
        case 2:
        case 'PENDING_FRAUD_CHALLENGE':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .PENDING_FRAUD_CHALLENGE;
        case 3:
        case 'REJECTED_FRAUD_CHALLENGE':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .REJECTED_FRAUD_CHALLENGE;
        case 4:
        case 'VERIFIED_FRAUD_CHALLENGE':
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .VERIFIED_FRAUD_CHALLENGE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
                .UNRECOGNIZED;
    }
}
exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusFromJSON = cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusFromJSON;
function cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusToJSON(object) {
    switch (object) {
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
            .FRAUD_CHALLENGE_STATUS_NOT_SET:
            return 'FRAUD_CHALLENGE_STATUS_NOT_SET';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
            .EXPIRED_FRAUD_CHALLENGE:
            return 'EXPIRED_FRAUD_CHALLENGE';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
            .PENDING_FRAUD_CHALLENGE:
            return 'PENDING_FRAUD_CHALLENGE';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
            .REJECTED_FRAUD_CHALLENGE:
            return 'REJECTED_FRAUD_CHALLENGE';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus
            .VERIFIED_FRAUD_CHALLENGE:
            return 'VERIFIED_FRAUD_CHALLENGE';
        case CardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusToJSON = cardInternalPaymentContextStripeRiskDataFraudChallengeFraudChallengeStatusToJSON;
function cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelFromJSON(object) {
    switch (object) {
        case 0:
        case 'CARD_TESTING_RISK_LEVEL_NOT_SET':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .CARD_TESTING_RISK_LEVEL_NOT_SET;
        case 1:
        case 'UNKNOWN_CARD_TESTING_RISK_LEVEL':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .UNKNOWN_CARD_TESTING_RISK_LEVEL;
        case 2:
        case 'ELEVATED_CARD_TESTING_RISK_LEVEL':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .ELEVATED_CARD_TESTING_RISK_LEVEL;
        case 3:
        case 'HIGH_CARD_TESTING_RISK_LEVEL':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .HIGH_CARD_TESTING_RISK_LEVEL;
        case 4:
        case 'HIGHEST_CARD_TESTING_RISK_LEVEL':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .HIGHEST_CARD_TESTING_RISK_LEVEL;
        case 5:
        case 'NORMAL_CARD_TESTING_RISK_LEVEL':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .NORMAL_CARD_TESTING_RISK_LEVEL;
        case 6:
        case 'NOT_ASSESSED_CARD_TESTING_RISK_LEVEL':
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .NOT_ASSESSED_CARD_TESTING_RISK_LEVEL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
                .UNRECOGNIZED;
    }
}
exports.cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelFromJSON = cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelFromJSON;
function cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelToJSON(object) {
    switch (object) {
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .CARD_TESTING_RISK_LEVEL_NOT_SET:
            return 'CARD_TESTING_RISK_LEVEL_NOT_SET';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .UNKNOWN_CARD_TESTING_RISK_LEVEL:
            return 'UNKNOWN_CARD_TESTING_RISK_LEVEL';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .ELEVATED_CARD_TESTING_RISK_LEVEL:
            return 'ELEVATED_CARD_TESTING_RISK_LEVEL';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .HIGH_CARD_TESTING_RISK_LEVEL:
            return 'HIGH_CARD_TESTING_RISK_LEVEL';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .HIGHEST_CARD_TESTING_RISK_LEVEL:
            return 'HIGHEST_CARD_TESTING_RISK_LEVEL';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .NORMAL_CARD_TESTING_RISK_LEVEL:
            return 'NORMAL_CARD_TESTING_RISK_LEVEL';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .NOT_ASSESSED_CARD_TESTING_RISK_LEVEL:
            return 'NOT_ASSESSED_CARD_TESTING_RISK_LEVEL';
        case CardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevel
            .UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelToJSON = cardInternalPaymentContextStripeRiskDataRiskAssessmentCardTestingRiskCardTestingRiskLevelToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=internal-payment-card.js.map